var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('sellheader'),_c('carousel'),_c('indexnews'),_c('project'),_c('videoplay'),_c('cooperation'),_c('footers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }